export default __webpack_public_path__ + "static/media/edit_tp_active.3ae43392.svg";